interface TextFieldProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  id: string;
  imgSrc?: string;
  imgAlt: string;
  label: string;
}

const TextField = ({
  imgSrc,
  imgAlt,
  label,
  placeholder,
  required,
  value,
  onChange,
  className,
  onBlur,
  autoFocus,
}: TextFieldProps) => {
  return (
    <>
      <label className="block text-sm font-medium mb-2" htmlFor="codeInput">
        <span className="inline-flex items-center ">
          {imgSrc && <img src={imgSrc} alt={imgAlt} className="mr-2 h-4" />}
          {label}
        </span>
      </label>
      <input
        className={`${className} p-2 rounded-md text-black focus:outline-none placeholder:text-[#CECECE]`}
        placeholder={placeholder}
        required={required}
        title="Vui lòng điền vào trường"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        autoFocus={autoFocus}
        onInvalid={(e) => {
          (e.target as HTMLInputElement).setCustomValidity(
            "Vui lòng điền vào trường."
          );
        }}
        onInput={(e) => {
          (e.target as HTMLInputElement).setCustomValidity("");
        }}
      />
    </>
  );
};

export default TextField;
